import axios from "axios";

const client = axios.create({
  baseURL:
    "https://theurbancleansolutions.com/api" ||
    "https://urbanclean-laundry-server.vercel.app/api" ||
    // process.env.REACT_APP_API_URL ||
    "http://localhost:5000/api",
  headers: { "Content-Type": "application/json" },
});

export const TOKEN_KEY = "uc_admin_token";

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";

    // An expired session drops straight back to the login screen.
    if (
      error.response?.status === 401 &&
      !String(error.config?.url).includes("/auth/admin/login")
    ) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== "/login")
        window.location.href = "/login";
    }

    return Promise.reject(
      Object.assign(new Error(message), {
        status: error.response?.status,
        data: error.response?.data,
      })
    );
  }
);

export default client;
